






















import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';

import LoraForwardersStore from '@/store/lora/LoraForwarders.store';

import Widget from '@/components/Utils/Widget.vue';
import LoraForwarderRunStatus from '@/components/Lora/Forwarder/LoraForwarderRunStatus.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {LoraForwarderRunStatus, Widget},
})
export default class LoraForwarderRunStatusWidget extends Mixins<BaseComponent>(BaseComponent) {
  @Prop({default: false})
  private widgetLoading!: boolean;

  @Prop({default: true})
  private showLink!: boolean;

  private forwardersStore: LoraForwardersStore = getModule(LoraForwardersStore, this.$store);

  private async mounted() {
    try {
      await this.forwardersStore.fetchActiveForwarder();
    } catch (error) {
      Notify.Error(this.logger, 'Could not get active forwarder', error);
    }

    if (this.forwarder) {
      await this.refreshState();
      await this.subscribeState();
    }
  }

  private async beforeDestroy() {
    await this.forwardersStore.unsubscribeActiveForwarderState();
  }

  get forwarder() {
    return this.forwardersStore.ActiveForwarder;
  }

  private async refreshState() {

    if (this.forwarder === null) {
      throw new Error('activeForwarder is null');
    }

    try {
      await this.forwardersStore.fetchActiveForwarderState();
    } catch (error) {
      this.logger.error(`Error getting '${this.forwarder.Id}' lora forwarder state`);
    }
  }

  private async subscribeState() {
    try {
      this.logger.debug(`Subscribing to forwarder status`);
      await this.forwardersStore.subscribeActiveForwarderState();
    } catch (error) {
      Notify.Warn(this.logger, `Could not subscribe to forwarder status`, error, ['Please refresh the status manually']);
    }
  }
}
